import { render, staticRenderFns } from "./tabNav.vue?vue&type=template&id=085cd660"
import script from "./tabNav.vue?vue&type=script&lang=js"
export * from "./tabNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports